import React, { useEffect, useRef, useState } from "react";
import fluid from "../../../../../assets/image/category/fluid.webp";
import { FaCheck } from "@react-icons/all-files/fa/FaCheck";
import { FaArrowRight } from "@react-icons/all-files/fa/FaArrowRight";
import engine from "../../../../../assets/image/services/engine.webp";
import gasmilage from "../../../../../assets/image/services/gasmilage.webp";
import misfiring from "../../../../../assets/image/services/misfiring.webp";
import fuel4 from "../../../../../assets/image/services/fuel4.webp";
import { Link } from "react-router-dom";
import check from "../../../../../assets/image/check.png";
import MyButton from "../../utils/Button/MyButton";

export default function Fuel() {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    // Trigger animation after component mounts
    setTimeout(() => setIsVisible(true), 100);
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );
  }, []);
  return (
    <div className="overflow-hidden">
      {/* Electrical Services*/}

      <div className="text-black ">
        {/* Image Column (5/12 on large) */}
        <div className="lg:col-span-5 md:col-span-1 relative flex flex-col w-full ">
          <img
            className="lg:h-[30rem] md:w-full md:h-[23rem] h-[20rem] w-full object-cover "
            src={fluid}
            alt="fuel"
          />
          <div class="absolute inset-0 bg-gradient-to-t from-[#2770ab]/65 to-transparent"></div>
          <div className="absolute inset-0 mb-[2.6rem] lg:mb-20 flex items-center justify-center text-white text-center ">
            <h3
              className={`text-white text-center font-bold absolute lg:text-6xl md:text-3xl text-2xl mb-4 
           transition-all duration-[4000ms] ease-in-out
                ${isVisible ? "opacity-100" : "opacity-0"}
              `}
            >
              VAP Fuel System Inspection & Repair
            </h3>
          </div>
          <div
            className={`w-full flex inset-0 items-center justify-center mt-14 absolute 
           transition-all duration-[950ms] delay-[900ms] ease-in-out
                ${
                  isVisible
                    ? "-translate-y-0 opacity-100"
                    : "translate-y-5 opacity-0"
                }
              `}
          >
            <Link to="/contact-us">
              {/* <button className="p-2 rounded text-orange-500 bg-orange-500 text-white cursor-pointer">
                Book Now
              </button> */}
              <MyButton
                text=" Fuel System Services"
                className="bg-orange-500 text-white py-[13px]  rounded-full text-base sm:text-lg md:text-xl font-bold transform transition-transform duration-500 hover:scale-105 shadow-md"
              />
            </Link>
          </div>
        </div>

        {/* Content Column (7/12 on large) */}
        <div className="bg-gradient-to-b from-white to-[#F8FAFC] py-[30px] lg:px-[12%] ">
          <div className="container mx-auto px-6 max-w-4xl  text-center ">
            <p className="text-xl lg:block md:block hidden text-gray-700 mb-6  ">
              A faulty fuel system can lead to engine misfires, stalling, hard
              starts, or reduced fuel efficiency. If you notice a strong
              gasoline smell, poor acceleration, or a sudden drop in mileage,
              it’s time to get your fuel system checked before the issue gets
              worse.
            </p>

            <p className="text-xl text-gray-700 mb-6 ">
              At Vancouver Auto Parts, we offer you expert fuel system
              inspections and repairs using high-quality automotive parts you
              can trust. As a reliable online auto parts store, we are committed
              to helping your vehicle run efficiently and safely with every
              mile.
            </p>

            {/* 
            <ul className="ps-1">
              <li className="hover:text-blue-900 flex items-center text-lg">
                <span className="h-5 w-5 flex items-center justify-center bg-blue-900 inline-block rounded-full me-2">
                  <FaCheck className="text-white p-0.5" />
                </span>
                Hard starting or no-start situations
              </li>
              <li className="hover:text-blue-900 flex items-center text-lg">
                <span className="h-5 w-5 flex items-center justify-center bg-blue-900 inline-block rounded-full me-2">
                  <FaCheck className="text-white p-0.5" />
                </span>
                Decreased fuel efficiency
              </li>
              <li className="hover:text-blue-900 flex items-center text-lg">
                <span className="h-5 w-5 flex items-center justify-center bg-blue-900 inline-block rounded-full me-2">
                  <FaCheck className="text-white p-0.5" />
                </span>
                Engine hesitation or surging
              </li>
              <li className="hover:text-blue-900 flex items-center text-lg">
                <span className="h-5 w-5  items-center justify-center bg-blue-900 inline-block rounded-full me-2">
                  <FaCheck className="text-white p-0.5" />
                </span>
                Unusual fuel odour inside or outside the vehicle
              </li>
              <li className="hover:text-blue-900 flex items-center text-lg">
                <span className="h-5 w-5 items-center justify-center bg-blue-900 inline-block rounded-full me-2">
                  <FaCheck className="text-white p-0.5" />
                </span>
                Stalling while idling or driving
              </li>
            </ul> */}
            <div
              className={`
           transition-all duration-[950ms] delay-[2500ms] ease-out
                ${
                  isVisible
                    ? "-translate-y-0 opacity-100"
                    : "translate-y-5 opacity-0"
                }
              `}
            >
              <Link to="/contact-us">
                {/* <button className="p-2 rounded text-orange-500 bg-orange-500 text-white cursor-pointer">
                Book Now
              </button> */}
                <MyButton
                  text="Book a same-day inspection"
                  className="mx-auto  py-[10px] transform transition-transform duration-500 hover:scale-105 "
                />
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-[#EFF6FF]    ">
        <div className="lg:py-[30px] md:py-[20px] py-[15px] text-center container">
          <h1
            className={`text-blue-900 font-bold text-[1.8rem] md:text-[2.6rem] lg:text-[3rem]    mb-2 text-center pb-2
           
              `}
          >
            Our Fuel System Services
          </h1>
          <p className="mb-3 lg:font-normal text-[1.35rem] lg:px-[9%]   text-center">
            Fuel needs to flow seamlessly from the tank to the engine, passing
            through multiple components that can wear out or fail over time. Our
            certified mechanics specialize in diagnosing and repairing fuel
            systems for all makes and models, ensuring optimal performance and
            fuel.
          </p>

          <div className="flex justtify-center items-center lg:px-[5%] py-2  sm:px-2 ">
            <div className="text-black text-center  h-[100%]  ">
              {/* first */}
              <div className=" flex lg:flex-row md:flex-col flex-col w-full max-h-[50%] lg:my-[4%] md:my-[4%] my-0 justify-between  ">
                <div className="lg:w-[50%] md:w-[97%] w-full lg:mb-0 mb-2 ">
                  <img
                    src={gasmilage}
                    alt=""
                    className="rounded-[4%] border-none outline-none box-s lg:w-[31rem]   lg:h-[22rem] md:h-[93%] h-[17rem]  w-full object-cover  "
                  />
                </div>

                <div className=" lg:text-start md:text-start sm:text-center min-h-[30%] my-auto lg:w-[50%] md:w-[95%] w-[100%]">
                  <p className="lg:text-[2.6rem] text-3xl  ">
                    <b>
                      Quality Of Fuel{" "}
                      <span className="text-[#2772AD]">Matters </span>
                    </b>
                  </p>
                  <p className="lg:font-normal text-gray-700  text-[1.24rem]">
                    Over time, contaminated fuel, clogged filters, and dirty
                    injectors restrict flow and reduce overall engine
                    performance. Replacing fuel filters and cleaning injectors
                    helps restore proper combustion, protect vital engine
                    components, and improve fuel efficiency. Routine fuel system
                    maintenance prevents harmful buildup that can lead to rough
                    idling, poor acceleration, and costly long-term engine
                    damage.
                    <div className="font-bold mt-2  ">
                      {" "}
                      <Link
                        to="/contact-us"
                        className="border-b-2 text-[1.3rem] border-blue-600 hover:opacity-70"
                      >
                        Get in touch <span>&#x27A1;</span>
                      </Link>
                    </div>
                  </p>
                </div>
              </div>
              {/* second */}
              <div className=" flex lg:flex-row md:flex-col-reverse flex-col-reverse w-full min-h-[30%] lg:my-[6%] my-[5%] justify-between   ">
                <div className=" lg:text-start md:text-start sm:text-center my-auto  lg:w-[50%] md:w-[95%] w-[100%]">
                  <p className="lg:text-[2.6rem] md:text-3xl text-3xl   ">
                    <b>
                      Fuel Leaks Lead to{" "}
                      <span className="text-[#2772AD]">Fires</span>
                    </b>
                  </p>

                  <p className="leading-normal lg:font-normal text-gray-700    text-[1.3rem]">
                    A leaking or cracked fuel line isn’t just inefficient—it’s a
                    serious fire risk. Fuel vapors can ignite near heat or
                    electrical components, putting your vehicle and safety at
                    risk. That’s why we thoroughly inspect all fuel lines,
                    pumps, and seals for signs of wear or damage and repair them
                    before trouble starts.
                    <div className="font-bold mt-2  ">
                      {" "}
                      <Link
                        to="/contact-us"
                        className="border-b-2 border-blue-600 hover:opacity-70"
                      >
                        Get in touch <span>&#x27A1;</span>
                      </Link>
                    </div>
                  </p>
                </div>
                <div className="lg:w-[50%] md:w-[97%] lg:mb-0 mb-2    flex justify-end">
                  <img
                    src={misfiring}
                    alt=""
                    className="rounded-[4%]   lg:w-[31.5rem] lg:h-[22rem] md:h-[93%] h-[17rem] object-fill"
                  />
                </div>
              </div>
              {/* third */}
              <div className="flex lg:flex-row md:flex-col flex-col w-full min-h-[30%] my-[4%]    justify-between  ">
                <div className="lg:w-[50%] md:w-[97%] lg:mb-0 mb-2   w-full">
                  <img
                    src={fuel4}
                    alt=""
                    className="rounded-[4%]   lg:w-[31rem]  lg:h-[22rem] md:h-[23rem] h-[17rem] w-full object-fill  "
                  />
                </div>

                <div className=" lg:text-start md:text-start sm:text-center my-auto  lg:w-[50%] md:w-[95%] w-[100%]">
                  <p className="lg:text-[2.6rem] md:text-3xl text-3xl tracking-tight ">
                    <b>
                      Sensors get Confused By{" "}
                      <span className="text-[#2772AD]">Dirt</span>
                    </b>
                  </p>

                  <p className="leading-normal lg:font-normal text-gray-700    text-[1.3rem]">
                    A contaminated fuel system doesn’t just affect
                    performance—it can throw off your car’s sensors. When
                    injectors or filters are clogged, sensors may detect false
                    readings, triggering error codes that confuse both you and
                    the ECU. Cleaning the fuel system restores accuracy,
                    improves efficiency, and prevents unnecessary repairs caused
                    by misleading alerts.
                    <div className="font-bold mt-2  ">
                      {" "}
                      <Link
                        to="/contact-us"
                        className="border-b-2 border-blue-600 hover:opacity-70"
                      >
                        Get in touch <span>&#x27A1;</span>
                      </Link>
                    </div>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <p className="mb-3 lg:font-normal text-center text-xl lg:px-36 md:px-2">
            Your fuel system impacts more than just engine power—it affects
            emissions, overall efficiency, and engine longevity. A dirty or
            failing fuel system can cause excess carbon buildup, premature wear,
            and higher fuel consumption.
            <p className="lg:block md:block hidden">
              {" "}
              Whether you’re looking for auto parts or expert repair services,
              regular fuel system maintenance improves throttle response,
              extends engine life, and helps you save the money on gas.
            </p>
          </p>
          <div className="w-full flex justify-center mb-3 transform transition-transform duration-500 hover:scale-105">
            <Link to="/contact-us">
              {/* <button className="p-2 rounded text-orange-500 bg-orange-500 text-white cursor-pointer flex items-center">
                Schedule Today
                <FaArrowRight className="ml-2" />
              </button> */}

              <MyButton text="Schedule Today" className="py-[8px] px-4" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
